export default __webpack_public_path__ + "static/media/california.fb7966eb.jpg";